var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabourIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6C11 7.65685 9.65685 9 8 9C6.34315 9 5 7.65685 5 6ZM8 1C5.23858 1 3 3.23858 3 6C3 8.76142 5.23858 11 8 11C10.7614 11 13 8.76142 13 6C13 3.23858 10.7614 1 8 1ZM15 1C14.4477 1 14 1.44772 14 2C14 2.55228 14.4477 3 15 3C16.6569 3 18 4.34315 18 6C18 7.65685 16.6569 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11C17.7614 11 20 8.76142 20 6C20 3.23858 17.7614 1 15 1ZM0 18.8C0 15.5967 2.59675 13 5.8 13H10.2C13.4033 13 16 15.5967 16 18.8C16 21.1196 14.1196 23 11.8 23H4.2C1.8804 23 0 21.1196 0 18.8ZM5.8 15C3.70132 15 2 16.7013 2 18.8C2 20.015 2.98497 21 4.2 21H11.8C13.015 21 14 20.015 14 18.8C14 16.7013 12.2987 15 10.2 15H5.8ZM17 13C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15H18.2C20.2987 15 22 16.7013 22 18.8C22 20.015 21.015 21 19.8 21H17C16.4477 21 16 21.4477 16 22C16 22.5523 16.4477 23 17 23H19.8C22.1196 23 24 21.1196 24 18.8C24 15.5967 21.4033 13 18.2 13H17Z",
    fill: "#0A71CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabourIcon);
export default __webpack_public_path__ + "static/media/LabourIcon.fa691b4cce9d8f9673766571f041f55a.svg";
export { ForwardRef as ReactComponent };